import {
  Box,
  Button,
  CircularProgress,
  // Dialog,
  // DialogActions,
  // DialogContent,
  // DialogTitle,
  Divider,
  SwipeableDrawer,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { GiftBrand } from "../models/GiftBrand";

interface BuyGiftDialogProps {
  open: boolean;
  onClose: () => void;
  brands: GiftBrand[];
  onSelect: (brand: GiftBrand) => void;
}

const BuyGiftDialog: React.FC<BuyGiftDialogProps> = ({
  open,
  onClose,
  brands,
  onSelect,
}) => {
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setLoading(true);
  };

  return (
    <SwipeableDrawer
      open={open}
      onClose={onClose}
      onOpen={() => {}}
      anchor="right"
      sx={{
        "& .MuiDrawer-paper": {
          width: { xs: "100%", sm: 400 },
          boxSizing: "border-box",
        },
      }}
    >
      <>
        <Box sx={{ p: 2, textAlign: "center" }}>
          <Typography variant="h6">Select Gift Card</Typography>
        </Box>
        <Divider />
        <Box
          sx={{
            pt: 2,
            display: "grid",
            gridTemplateColumns: "repeat(1, 1fr)",
            gap: 2,
            justifyItems: "center",
          }}
        >
          {brands.map((brand) => (
            <Box
              key={brand.productId}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                padding: 2,
                border: "1px solid #ccc",
                borderRadius: 1,
                width: "100%",
                gap: 1.5,
                "&:hover": { boxShadow: 1 },
              }}
            >
              <img
                src={brand.productImage}
                alt={brand.brandName}
                style={{
                  width: "100%",
                  height: 150,
                  objectFit: "contain",
                  borderRadius: 4,
                }}
              />
              <span>{brand.brandName}</span>
              {/* <span>{brand.productDescription}</span> */}
              <Button
                variant="contained"
                color="primary"
                onClick={() => onSelect(brand)}
                fullWidth
              >
                Select
              </Button>
            </Box>
          ))}
        </Box>
        <Box sx={{ p: 2, textAlign: "center" }}>
          <Button onClick={onClose} disabled={loading}>
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            color="primary"
            variant="contained"
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} /> : "Select Gift Card"}
          </Button>
        </Box>
      </>
    </SwipeableDrawer>
  );
};

export default BuyGiftDialog;
